import {
  Component,
  EventEmitter,
  HostListener,
  Inject,
  Input,
  OnInit,
  Output
} from '@angular/core';
import { DOCUMENT } from '@angular/common';
import {
  NavigationStart,
  Router,
  ActivatedRoute
} from '@angular/router';
import { PermissionsInterface } from '../../interfaces/permissions.interface';
import { User } from '../../decorators/user.decorator';
import { LocalStorageService } from '../../services/storage/local-storage.service';
import { ThemeEventsService } from '../../theme/theme-event.service';
import { PermissionsService } from '../../permissions/permissions.service';
import { AuthUserModel } from '../../models';
import { Config, WEB_CONFIG } from '../../config';

@Component({
  selector: 'sc-menu',
  styleUrls: ['./menu.component.css'],
  templateUrl: './menu.component.html'
})
export class MenuComponent implements OnInit, PermissionsInterface {
  @Input() public isMenuDeployed: boolean;

  @Output() public toggleMenu: EventEmitter<any> = new EventEmitter<any>();
  @Input() public theme: string;
  @User() public user: AuthUserModel;

  public currentScroll = 0;
  public myAccountUrl: string;

  constructor(
    private activatedRoute: ActivatedRoute,
    private localStorage: LocalStorageService,
    private themeEventsService: ThemeEventsService,
    @Inject(DOCUMENT) private document: any,
    private permissionsService: PermissionsService,
    private router: Router,
    @Inject(WEB_CONFIG) private config: Config
  ) {}

  public ngOnInit() {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.toggleMenu.emit();
      }
    });
    this.initPermissionsService();
    this.myAccountUrl = 'authorization/account/consult/' + this.user.id;

    this.themeEventsService.switchThemeEmitter.subscribe(
      () => (this.theme = this.localStorage.get('newTheme'))
    );
  }

  @HostListener('window:scroll', [])
  public onWindowScroll() {
    const numberVar = this.document.documentElement.scrollTop;
    if (numberVar !== this.currentScroll) {
      this.toggleMenu.emit();
    }
  }

  public initPermissionsService(): void {
    this.permissionsService.init();
  }

  public navigate(module: string = '', route: string) {
    if (!route.startsWith('/')) {
      route = '/' + route;
    }

    if (module) {
      if (window.location.pathname.startsWith(`/${module}`)) {
        this.router.navigateByUrl(route);
      } else {
        window.location.href = `${this.config.api_url}/${module}${route}`;
      }
    } else {
      window.location.href = `${this.config.api_url}${route}`;
    }
  }
}
